import { Message } from 'element-ui'

// 获取cookie、
export function getCookie(name) {
  // eslint-disable-next-line one-var
  var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  // eslint-disable-next-line no-cond-assign
  if (arr = document.cookie.match(reg)) { return (arr[2]) } else { return null }
}

// 设置cookie,增加到vue实例方便全局调用 单位小时
export function setCookie(cName, value, expireTime) {
  var exdate = new Date()
  // exdate.setDate(exdate.getDate() + expiredays)
  exdate.setTime(exdate.getTime() + (expireTime + 8) * 60 * 60 * 1000)
  document.cookie = cName + '=' + escape(value) + ((expireTime == null) ? '' : ';expires=' + exdate.toGMTString())
}

// 删除cookie
export function delCookie(name) {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

// 获取字符数
export function getStringLengthForChinese(val) {
  const str = val ? val.toString(val) : ''
  let result = 0
  for (let i = 0; i < str.length; i++) {
    const temp = str.charCodeAt(i)
    if ((temp > 0x0001 && temp <= 0x007e) || (temp >= 0xff60 && temp <= 0xff9f)) {
      result += 1
    } else {
      result += 2
    }
  }
  return result
}

/**
 * 等保校验文件类型
 * @param {*} rawFile
 * @returns
 */
export const fileTypeCheck = (rawFile) => {
  const fileType = ['.py', '.pyc', '.pyo', '.pyd', '.java', '.class', '.js', '.sh', '.ps1', '.rb', '.lua', '.bat', '.pl']
  if (fileType.includes(rawFile.name.substring(rawFile.name.lastIndexOf('.')))) {
    Message.error('请上传正确的文件类型')
    return false
  }
  return true
}

/**
 * 等保校非法图片提示
 * @param {*} message
 * @returns
 */
export const illegalMessage = (message, defaultMessage = '文件上传失败') => {
  message = message ? JSON.parse(message) : ''
  Message.error(message.detail || defaultMessage)
}



// WEBPACK FOOTER //
// ./src/util/util.js